import {ProjectSmall} from '@/features/projects/types'
import {TreatmentRequestSmall} from '@/features/treatment-requests/types'
import {MedicalReportSmall} from '@/features/medical-reports/types'
import {useTranslation} from '@/translations/i18n'
import {formatDate} from '@/dayjs'
import {ConversationEntityType} from '@/features/conversations/types'
import {Text} from '@/components/ui/text/Text'

type ConversationEntityDetailsProps = {
    entityType: ConversationEntityType
    entity:
        | Pick<ProjectSmall, 'id' | 'code' | 'startDate' | 'expirationDate'>
        | Pick<TreatmentRequestSmall, 'id' | 'createdAt'>
        | Pick<MedicalReportSmall, 'id' | 'date'>
        | null
}

export const ConversationEntityDetails = ({entityType, entity}: ConversationEntityDetailsProps) => {
    const {t} = useTranslation()

    if (!entity) return null

    const makeEntityName = () => {
        if (entityType === 'project') {
            // Type guard: check if entity has 'code' property (project-specific)
            if ('code' in entity && 'startDate' in entity && entity.startDate) {
                return t('projects:project_number_date', {
                    code: entity.code,
                    date: formatDate(entity.startDate, 'DD/MM/YYYY')
                })
            }
        } else if (entityType === 'treatment_request') {
            // Type guard: check if entity has 'createdAt' property (treatment request-specific)
            if ('createdAt' in entity) {
                return t('treatment_requests:treatment_request_date', {
                    date: formatDate(entity.createdAt, 'DD/MM/YYYY')
                })
            }
        } else if (entityType === 'medical_record_report') {
            // Type guard: check if entity has 'date' property (medical report-specific)
            if ('date' in entity) {
                return t('medical_records:medical_report_date', {date: formatDate(entity.date, 'DD/MM/YYYY')})
            }
        }

        return ''
    }

    const entityName = makeEntityName()

    if (!entityName) {
        return null
    }

    return (
        <Text palette="neutral" shade="600" size="textXs">
            {entityName}
        </Text>
    )
}
